<div>
    <mat-drawer-container [hasBackdrop]="false" autosize style="height: calc(100vh - 50px); width:100%">
        <mat-drawer #drawer mode="side" opened style="display: block;">
            <div class="heading"> Folders  </div>

            <div class="clearfix mt-1 mr-1"><button mat-stroked-button (click)="createFolder()" class="float-right pr-2">
                    <mat-icon>add</mat-icon> New
                </button>
            </div>
            <div class="m-2 text-center" *ngIf="noFolders">
                No Folders to view
            </div>
            <mat-tree *ngIf="!noFolders" [dataSource]="virtualFolders" [treeControl]="treeControl">
                <!-- This is the tree node template for leaf nodes -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="20">
                    <!-- use a disabled button to provide padding for tree leaf -->
                    <button mat-icon-button matTreeNodeToggle style="min-width: 20px;" [attr.aria-label]="'toggle ' + node.folder_name">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'folder_open' : 'folder_open'}}
                        </mat-icon>
                    </button>
                    <button [ngClass]="node.id === selectedFolderId ? 'bold-text' : 'normal-text'" mat-button (click)="selectFolder(node.folder_name, node.id)">
                             {{node.folder_name}}
                    </button>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding
                    [matTreeNodePaddingIndent]="20">
                    <button mat-icon-button matTreeNodeToggle style="min-width: 20px;" [attr.aria-label]="'toggle ' + node.folder_name">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'folder_open' : 'folder'}}
                        </mat-icon>
                    </button>
                    <button [ngClass]="node.id === selectedFolderId ? 'bold-text' : 'normal-text'" mat-button (click)="selectFolder(node.folder_name, node.id)">
                        {{node.folder_name}}</button>
                </mat-tree-node>
            </mat-tree>
        </mat-drawer>

        <mat-drawer-content>
            <div class="card m-2" *ngIf="!folderSelected && !isMainPage && !noDocuments && !hideDocList">
                <div class="card-body"><strong>Please select a folder</strong><br> 1. To view the documents
                    associated with it.<br>
                </div>
            </div>

            <div class="m-2">
                <div *ngIf="folderSelected && !isMainPage && !hideDocList">
                    <div class="Tabletitle">Document List for Folder - {{selectedFolderName}}
                        ({{totalDocumentCount|number}})

                    </div>

                    <div class="btn-group fit-content mt-2 mb-2">
                        <button class="btn pr-2" mat-stroked-button
                            (click)="updateFolder(selectedFolderId)">
                            <mat-icon class="mb-1">edit</mat-icon> Update
                        </button>
                        <button class="btn pr-2" mat-stroked-button (click)="createSubFolder()">
                            <mat-icon class="mb-1">add</mat-icon> Sub Folder
                        </button>
                        <button class="btn pr-2" mat-stroked-button (click)="deleteFolder(selectedFolderId)">
                            <mat-icon class="mb-1">delete</mat-icon> Delete
                        </button>
                    </div>

                    <div *ngIf="noDocuments" class="text-center mt-2">
                        <strong>{{selectedFolderName}}</strong> has no documents to display.
                    </div>
                </div>
                <div *ngIf="docResultsList && folderSelected && !isMainPage && !noDocuments && !hideDocList">
                    <table aria-describedby="doc-table" mat-table [dataSource]="docResultsList" matSort>

                        <ng-container matColumnDef="select">
                            <th id="select" mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let row">
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="title">
                            <th id="title" mat-header-cell *matHeaderCellDef mat-sort-header> Document Title </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.documentName}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="create_date">
                            <th id="create_date" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded date </th>
                            <td mat-cell *matCellDef="let element"> {{element.createdDate | date }} </td>
                        </ng-container>
                        <ng-container matColumnDef="created_by">
                            <th id="created_by" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded By </th>
                            <td mat-cell *matCellDef="let element"> {{element.created_by }} </td>
                        </ng-container>
                        <ng-container matColumnDef="modified_date">
                            <th id="modified_date" mat-header-cell *matHeaderCellDef mat-sort-header> Modified date
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.modified_date | date }} </td>
                        </ng-container>

                        <!-- dynamic columns -->
                        <ng-container *ngFor="let column of documentCols">
                            <ng-container *ngIf="column.indexOf('display_') === 0" matColumnDef="{{column}}">
                                <th id="{{column | stripDisplay}}" mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{column | stripDisplay}} </th>
                                <td mat-cell *matCellDef="let element"> {{ element[column] }} </td>
                            </ng-container>
                        </ng-container>
                        <!-- end dynamic columns-->

                        <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
                        <tr mat-row *matRowDef="let row; columns: documentCols;"
                            (click)="getDocDetails($event, row, drawer)" class="element-row">
                        </tr>
                    </table>
                    <mat-paginator #myPaginator [pageSizeOptions]="[5,10, 20, 50]" [pageSize]="10" showFirstLastButtons>
                    </mat-paginator>
                    <div *ngIf="loadNext" class="loadButton">
                        <button mat-raised-button (click)=next()>Next 200<mat-icon>keyboard_arrow_right
                            </mat-icon></button>
                    </div>
                    <div *ngIf="loadPrevious" class="loadButton">
                        <button mat-raised-button (click)=previous()>
                            <mat-icon>keyboard_arrow_left</mat-icon>Previous 200
                        </button>
                    </div>
                </div>
                <div *ngIf="isMainPage && !hideDocList">
                    <app-virtual-folders-config [isUpdateFolder]="isUpdateFolder" [selectedFolderId]="selectedFolderId"
                        [isCreateFolder]="isCreateFolder" [isCreateSubFolder]="isCreateSubFolder"
                        (isMainPage)="onReturnPage($event)"></app-virtual-folders-config>
                </div>
                <div class="col" *ngIf="selectedDoc && hideDocList">
                    <app-display-search-doc *ngIf="!displayImageTrust" [selectedDocument]="selectedDoc" [searchResultsList]="docResultsList"
                        (hideDocList)="onHideDocList($event)">
                    </app-display-search-doc>
                    <div *ngIf="displayImageTrust"  class="heading">{{selectedFolderName}}</div>
                    <div *ngIf="displayImageTrust" class="row">
                        <div class="col-12 btn-group" role="group" aria-label="First group">
                            <iframe [src]="iframeUrl | safe" [width]="loading ? '0%' : '100%'" style="height: calc(100vh - 50px);"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>